import app from 'flarum/forum/app';
import on from './gate';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
export default class RequestSong extends Component {
  query = '';
  results = [];
  error = '';
  confirmation = '';
  ready = null;
  loading = false;
  requesting = '';
  sequence = 0;
  onremove() {
    clearTimeout(this.timer);
    this.sequence++;
  }
  search(q) {
    this.query = q;
    this.error = '';
    this.confirmation = '';
    this.ready = null;
    clearTimeout(this.timer);
    const seq = ++this.sequence;
    if (q.trim().length < 2) {
      this.results = [];
      this.loading = false;
      return;
    }
    this.loading = true;
    this.timer = setTimeout(() => app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/challenges/song-search',
      params: {
        q: q.trim()
      },
      errorHandler: () => {}
    }).then(r => {
      if (seq === this.sequence) this.results = r.data;
    }).catch(e => {
      if (seq === this.sequence) this.error = e.status === 503 ? "Song search isn't set up yet" : e.status === 429 ? 'Too many searches. Try again in a minute.' : 'Search is unavailable. Try again.';
    }).finally(() => {
      if (seq === this.sequence) this.loading = false;
      m.redraw();
    }), 350);
  }
  async request(song) {
    this.requesting = song.spotify_track_id;
    this.error = '';
    try {
      const r = await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/challenges/request-song',
        body: {
          spotify_track_id: song.spotify_track_id
        }
      });
      this.confirmation = r.data.ready ? 'This song is already in the library.' : "We'll build it and let you know";
      this.ready = r.data.ready ? r.data : null;
      this.results = [];
    } catch {
      this.error = 'Could not request this song. Please try again.';
    } finally {
      this.requesting = '';
      m.redraw();
    }
  }
  view() {
    if (!on()) return null;
    return m("section", {
      className: "Learn-request"
    }, m("span", {
      className: "Learn-eyebrow"
    }, "Your next favourite song"), m("h2", null, "Request a song"), m("p", null, "Can't find your song? Pick the exact recording and we'll put a Learn page together. We check every page by hand before it goes live, so it can take a few days."), app.session.user ? m('[', null, m("label", {
      className: "Learn-searchLabel",
      for: "learn-request-search"
    }, "Search Spotify"), m("input", {
      id: "learn-request-search",
      className: "FormControl",
      type: "search",
      placeholder: "Search a song or artist",
      value: this.query,
      oninput: e => this.search(e.target.value)
    }), this.loading && m("p", {
      role: "status"
    }, "Searching\u2026"), this.error && m("p", {
      role: "alert"
    }, this.error), this.confirmation && m("div", {
      className: "Learn-confirmation",
      role: "status"
    }, m("i", {
      className: "fas fa-check-circle",
      "aria-hidden": "true"
    }), " ", m("strong", null, this.confirmation), !this.ready && m("p", null, "We check it by hand before it goes live. You'll get a forum notification when it's ready to learn."), this.ready && m(Link, {
      href: app.route('challenges.learn', {
        slug: this.ready.slug
      })
    }, "Open Learn page \u2192")), m("ul", {
      className: "Learn-request-results"
    }, this.results.map(song => m("li", {
      key: song.spotify_track_id
    }, song.image_url && m("img", {
      src: song.image_url,
      alt: ""
    }), m("span", null, m("strong", null, song.track), m("span", null, song.artist), m("small", null, song.album, " \xB7 ", song.year)), m(Button, {
      className: "Button",
      loading: this.requesting === song.spotify_track_id,
      disabled: !!this.requesting,
      onclick: () => this.request(song)
    }, "Request song")))), this.query.length >= 2 && !this.loading && !this.results.length && !this.confirmation && !this.error && m("p", null, "No recordings found. Try the artist or another song title.")) : m("div", {
      className: "Learn-request-login"
    }, m(Button, {
      className: "Button Button--primary",
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
    }, "Log in to request a song"), m("span", null, "The library is open to everyone.")));
  }
}